import { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import IconLink from 'components/Shared/IconLink/Index'
import FilterPanelSearchInput from './FilterPanelSearchInput'

const StyledWrapper = styled.div`
  display: inline-flex;
  height: 24px;
  justify-content: flex-end;
  align-items: center;
  position: relative;
`

const SearchButton = styled(IconLink)`
  padding-right: 4px;
`

const FilterPanelSearch = ({
  initialValue, onChange, placeholder, buttonTooltip, tooltipId,
}) => {
  const [inputValue, setInputValue] = useState(initialValue || '')

  const onSearch = () => {
    onChange(inputValue)
  }

  const onClear = () => {
    setInputValue('')
    if (initialValue) {
      onChange('')
    }
  }

  const onInputChange = (event) => {
    setInputValue(event.target.value)
  }

  const onKeyPress = (event) => {
    if (event.key === 'Enter') {
      onChange(inputValue)
    }
  }

  const onKeyDown = (event) => {
    if (event.key === 'Escape') {
      setInputValue('')
    }
  }

  return (
    <StyledWrapper>
      <SearchButton
        iconName='icon-search'
        onClick={onSearch}
        data-tooltip-content={buttonTooltip}
        data-tooltip-id={tooltipId}
      />
      <FilterPanelSearchInput
        value={inputValue}
        onChange={onInputChange}
        onClear={onClear}
        onSearch={onSearch}
        onKeyPress={onKeyPress}
        placeholder={placeholder}
        onKeyDown={onKeyDown}
      />
    </StyledWrapper>
  )
}


FilterPanelSearch.propTypes = {
  initialValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  buttonTooltip: PropTypes.string,
  tooltipId: PropTypes.string,
}

export default FilterPanelSearch
